<template>
  <div class="main">
    <div class="card">
      <div class="card-body p-4 text-center">
        <h2 class="mb-2">Shopify</h2>
        <p class="text-secondary mb-4">
          Estas accediendo desde Shopify. Para continuar debes iniciar sesion.
        </p>
        <a-button
          type="primary"
          size="large"
          @click="onLogin">
          Iniciar sesion
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopifyPublicEntry',
  computed: {
    targetUrl() {
      const account = this.$route.query.account
      if (account) {
        return `/shops?account=${account}`
      }
      return '/accounts'
    },
  },
  mounted() {
    if (this.$auth && this.$auth.isAuthenticated) {
      this.$router.replace(this.targetUrl)
    }
  },
  methods: {
    onLogin() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: this.targetUrl } })
    },
  },
}
</script>
